import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import GlobalModel from 'echarts/lib/model/Global';
import GraphSeriesModel, { GraphNodeItemOption } from 'echarts/lib/chart/graph/GraphSeries';
import { beeswarmLayout, InputNode } from './layoutHelper';
export interface BeesWarmGraphSeriesModel extends GraphSeriesModel {
  beeswarmLayout: any;
}

export interface NodeFormatted {
  point: number[];
  fixed: boolean;
  value: number;
  radius: number;
}

export function graphBeeswarmLayout(ecModel: GlobalModel, api: ExtensionAPI) {
  ecModel.eachSeriesByType('graph', function (graphSeries: BeesWarmGraphSeriesModel) {
    const coordSys = graphSeries.coordinateSystem;
    const layout = graphSeries.get('layout') as unknown;
    if (!coordSys || coordSys.type !== 'view') {
      return;
    }
    if (layout === 'beeswarm') {
      graphSeries.beeswarmLayout && graphSeries.beeswarmLayout.dispose();

      const preservedPoints = graphSeries.preservedPoints || {};

      const graph = graphSeries.getGraph();
      const nodeData = graph.data;

      if (graphSeries.preservedPoints) {
        nodeData.each(function (idx) {
          const id = nodeData.getId(idx);
          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
        });
      }

      const nodes = nodeData.mapArray('value', function (value: number, idx) {
        const point =
          (nodeData.getItemLayout(idx) as number[]) ||
          nodeData.getItemModel<GraphNodeItemOption>(idx).get('position');
        return {
          idx,
          fixed: nodeData.getItemModel<GraphNodeItemOption>(idx).get('fixed'),
          point: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point,
          value,
          radius: (nodeData.getItemModel<GraphNodeItemOption>(idx).get('symbolSize') as number) / 2
        };
      }) as NodeFormatted[];

      const beeswarmInstance = beeswarmLayout(api, ecModel, nodes as InputNode[], graphSeries);

      beeswarmInstance.innerCallBack(nodes => {
        nodes.forEach((d, i) => {
          const isFixed = d.fx && d.fy;
          if (isFixed) {
            d.x = (graph.getNodeByIndex(i).getLayout() as number[])[0];
            d.y = (graph.getNodeByIndex(i).getLayout() as number[])[1];
          } else {
            graph.getNodeByIndex(i).setLayout([d.x, d.y]);
          }
          preservedPoints[nodeData.getId(i)] = [d.x, d.y];
        });
      });

      beeswarmInstance.init();

      graphSeries.beeswarmLayout = beeswarmInstance;
      graphSeries.preservedPoints = preservedPoints;
    } else {
      graphSeries.beeswarmLayout = null;
    }
  });
}
